var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.9914C23.9917 10.0701 23.6283 9.18922 22.9886 8.53968L15.6343 1.00925C15.3131 0.68308 14.8786 0.5 14.4257 0.5C13.9728 0.5 13.5383 0.68308 13.2171 1.00925C13.0565 1.17206 12.9289 1.36575 12.8419 1.57916C12.7549 1.79256 12.7101 2.02146 12.7101 2.25265C12.7101 2.48384 12.7549 2.71274 12.8419 2.92614C12.9289 3.13955 13.0565 3.33324 13.2171 3.49605L18.8571 9.24018H1.71429C1.25963 9.24018 0.823594 9.42469 0.502103 9.75312C0.180612 10.0815 0 10.527 0 10.9914C0 11.4559 0.180612 11.9013 0.502103 12.2298C0.823594 12.5582 1.25963 12.7427 1.71429 12.7427H18.8571L13.2171 18.5044C12.8943 18.8318 12.7121 19.2768 12.7105 19.7416C12.7089 20.2063 12.888 20.6526 13.2086 20.9824C13.5291 21.3122 13.9647 21.4983 14.4197 21.5C14.8746 21.5016 15.3115 21.3186 15.6343 20.9911L22.9886 13.4607C23.6324 12.8069 23.9962 11.9189 24 10.9914Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.e263d89016cb07d6c45436e47701c6cf.svg";
export { ForwardRef as ReactComponent };